import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/reliability')({
  component: ReliabilityLayout,
});

function ReliabilityLayout() {
  return <Outlet />;
}
